import script from "./ProductEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductEvents.vue?vue&type=script&setup=true&lang=js"

import "./ProductEvents.vue?vue&type=style&index=0&id=6df7bb51&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6df7bb51"]])

export default __exports__